<template>
  <div class="page">
    <div class="pagebox">
      <div class="user">
        <img src="/static/user.jpg" alt="" />
      </div>
      <div class="name">尊敬的用户</div>
      <div class="welcom">欢迎来到中医药商城，正在验证信息...</div>
      <div class="success" v-if="isSuccess && yanzheng">
        <div class="tit">验证成功!</div>
        <div class="btn">
          <van-button type="primary" round @click="submit"
            >进入线上平台</van-button
          >
        </div>
      </div>
      <div class="fail" v-if="!isSuccess && yanzheng">
        <div class="tit">验证失败! {{ msg || "" }}</div>
        <div class="tit">请返回一卡通登陆后再验证。</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  name: "HelloWorld",
  data() {
    return {
      isSuccess: true,
      yzm: "",
      herf: "",
      yanzheng: false,
      msg: "",
    };
  },
  created() {
    if (window.location.href.indexOf("Yzm") == -1) {
      this.yanzheng = true;
          this.isSuccess = false;
          this.msg = '参数有误';
          Toast.fail("验证失败");
          return false;
    }else{
      this.yzm = window.location.href.split('?')[1].split('#')[0].split('=')[1];
    console.log(this.yzm, "111");
    Toast.loading({
      message: "验证中...",
      forbidClick: true,
    });

    this.$axios
      .post("/api/get_scheme", {
        yzm: this.yzm,
      })
      .then((res) => {
        if (res.status == 200) {
          this.yanzheng = true;
          this.isSuccess = true;
          this.herf = res.data.scheme;
          Toast.success("已验证");
        } else {
          this.yanzheng = true;
          this.isSuccess = false;
          this.msg = res.msg;
          Toast.fail("验证失败");
        }
      });
    }
    
  },
  methods: {
    submit() {
      try {
        window.location.href = this.herf;
      } catch (error) {
        window.open(this.herf);
      }
    },
  },
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page {
  min-height: 100vh;
  font-size: 16px;
  background-image: linear-gradient(to right, #faf1f2, #d9e4f5);
}
.pagebox {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background-image: linear-gradient(to bottom, rgba(252, 252, 252, 0), #ffffff);
}
.user {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
}
.name {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
  color: #000000;
  font-weight: 600;
}
.welcom {
  width: 100%;
  height: 50px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  background-color: #7597f5;
  border-radius: 14px;
  line-height: 50px;
}
.success {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  font-size: 18px;
  color: #37c6ff;
  button {
    margin-top: 20px;
    width: 180px;
  }
}
.fail {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  font-size: 18px;
  color: #ff4848;
  .tit {
    margin-bottom: 20px;
    line-height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue